export interface AiPromptBoxAttachmentsProps {
  id: string;
}

export type PromptAttachment = ImageAttachment | DesignAttachment;

export interface ImageAttachment {
  hashedFilename: string;
  extension: string;
  source: string;
  type: PromptAttachmentType.IMAGE;
}

export interface DesignAttachment {
  designId: string;
  type: PromptAttachmentType.DESIGN;
}

export enum PromptAttachmentType {
  IMAGE = 'image',
  DESIGN = 'design',
}

export enum PromptAttachmentDivider {
  HORIZONTAL_LINE = 'horizontal-line',
}

export type AttachmentDropdownConfig = (PromptAttachmentType | PromptAttachmentDivider)[];

export interface AiPromptBoxAttachments {
  items: PromptAttachment[];
  dropdown: AttachmentDropdownConfig;
}